import { ActionKeys } from '~/actions/constants';
import Manifest, {
  ManifestGeneratePayload,
  ManifestGroups,
  ManifestGroupsRequestPayload,
} from '~/types/Manifests';

export function fetchManifests() {
  return <const>{
    type: ActionKeys.MANIFESTS_FETCH,
  };
}

export function fetchManifestsSuccess(payload: Manifest[]) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_FETCH_SUCCESS,
  };
}

export function fetchManifestsSuccessTerminalState(payload: Manifest[]) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_FETCH_SUCCESS_TERMINAL_STATE,
  };
}

export function fetchManifestsGroups(payload: ManifestGroupsRequestPayload) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_GROUPS_FETCH,
  };
}

export function fetchManifestsGroupsSuccess(payload: ManifestGroups) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_GROUPS_FETCH_SUCCESS,
  };
}

export function fetchManifestsGroupsError(payload: Error) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_GROUPS_FETCH_ERROR,
  };
}

export function fetchManifestsError(payload: Error) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_FETCH_ERROR,
  };
}

export function downloadManifestDocumentZip(manifestID: number) {
  return <const>{
    payload: manifestID,
    type: ActionKeys.MANIFESTS_DOWNLOAD_ZIP,
  };
}

export function downloadManifestDocumentZipSuccess() {
  return <const>{
    type: ActionKeys.MANIFESTS_DOWNLOAD_ZIP_SUCCESS,
  };
}

export function downloadManifestDocumentZipError() {
  return <const>{
    type: ActionKeys.MANIFESTS_DOWNLOAD_ZIP_ERROR,
  };
}

// TODO: Type payload
export function updateManifestsAddress(payload) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_UPDATE_ADDRESS,
  };
}

export function generateManifest(payload: ManifestGeneratePayload) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_GENERATE,
  };
}

export function generateManifestSuccess() {
  return <const>{
    type: ActionKeys.MANIFESTS_GENERATE_SUCCESS,
  };
}

export function generateManifestError(payload: Error) {
  return <const>{
    payload,
    type: ActionKeys.MANIFESTS_GENERATE_ERROR,
  };
}

export function startManifestsPolling(manifestsToPoll: string[]) {
  return <const>{
    payload: {
      manifestsToPoll,
    },
    type: ActionKeys.MANIFESTS_POLL_START,
  };
}

export function stopManifestsPolling() {
  return <const>{
    type: ActionKeys.MANIFESTS_POLL_END,
  };
}

export type ManifestsActions =
  | ReturnType<typeof fetchManifests>
  | ReturnType<typeof fetchManifestsSuccess>
  | ReturnType<typeof fetchManifestsSuccessTerminalState>
  | ReturnType<typeof updateManifestsAddress>
  | ReturnType<typeof fetchManifestsGroups>
  | ReturnType<typeof fetchManifestsGroupsSuccess>
  | ReturnType<typeof fetchManifestsGroupsError>
  | ReturnType<typeof fetchManifestsError>
  | ReturnType<typeof generateManifest>
  | ReturnType<typeof generateManifestSuccess>
  | ReturnType<typeof downloadManifestDocumentZip>
  | ReturnType<typeof downloadManifestDocumentZipSuccess>
  | ReturnType<typeof downloadManifestDocumentZipError>
  | ReturnType<typeof generateManifestError>
  | ReturnType<typeof startManifestsPolling>
  | ReturnType<typeof stopManifestsPolling>;
